import _ from 'lodash';
import { AnyAction } from 'redux';
import { IDictionary } from '~utilities/IDictionary';
import {
    IAbaHistoriesSetAction,
    IAbaSetAction,
    IAbaTransactionsSetAction,
    IAbasSetAction,
    IUnallocatedTransactionsSetAction,
} from './actions';
import IWarehouseLoanTransaction from '~Api/Warehouse/IWarehouseLoanTransaction';
import WarehouseLoanTransactionAbasActionsEnum from './ActionsEnum';
import IWarehouseLoanTransactionAba from '~Api/WarehouseLoanTransactionAba/IWarehouseLoanTransactionAba';
import IWarehouseLoanTransactionAbaHistory from '~Api/WarehouseLoanTransactionAba/IWarehouseLoanTransactionAbaHistory';

export interface IWarehouseLoanTransactionsAbasState {
    abaHistories: IDictionary<IWarehouseLoanTransactionAbaHistory[]>;
    abas: IDictionary<IWarehouseLoanTransactionAba>;
    abaTransactionUuids: IDictionary<string[]>;
    abaTypeGroupUuids: IDictionary<string[]>;
    unallocatedTransactionUuids: IDictionary<string[]>;
}

const initialData: IWarehouseLoanTransactionsAbasState = {
    abaHistories: {},
    abaTransactionUuids: {},
    abaTypeGroupUuids: {},
    abas: {},
    unallocatedTransactionUuids: {},
};

export function warehouseLoanTransactionAbasReducer(
    state: IWarehouseLoanTransactionsAbasState = initialData,
    action: AnyAction,
): IWarehouseLoanTransactionsAbasState {
    switch (action.type) {
        case WarehouseLoanTransactionAbasActionsEnum.AbasSet: {
            const typedAction: IAbasSetAction = action as IAbasSetAction;

            const abas: IDictionary<IWarehouseLoanTransactionAba> = {};
            const abaUuids: string[] = [];

            _.each(typedAction.abas, (aba: IWarehouseLoanTransactionAba) => {
                abas[aba.uuid] = aba;
                abaUuids.push(aba.uuid);
            });

            return {
                ...state,
                abaTypeGroupUuids: {
                    ...state.abaTypeGroupUuids,
                    [typedAction.abaTypeGroup]: abaUuids,
                },
                abas: {
                    ...state.abas,
                    ...abas,
                },
            };
        }

        case WarehouseLoanTransactionAbasActionsEnum.AbaHistoriesSet: {
            const typedAction: IAbaHistoriesSetAction = action as IAbaHistoriesSetAction;

            return {
                ...state,
                abaHistories: {
                    ...state.abaHistories,
                    [typedAction.uuid]: typedAction.histories,
                },
            };
        }

        case WarehouseLoanTransactionAbasActionsEnum.AbaSet: {
            const typedAction: IAbaSetAction = action as IAbaSetAction;

            return {
                ...state,
                abas: {
                    ...state.abas,
                    [typedAction.aba.uuid]: typedAction.aba,
                },
            };
        }

        case WarehouseLoanTransactionAbasActionsEnum.AbaTransactionsSet: {
            const typedAction: IAbaTransactionsSetAction = action as IAbaTransactionsSetAction;

            return {
                ...state,
                abaTransactionUuids: {
                    ...state.abaTransactionUuids,
                    [typedAction.uuid]: _.map(typedAction.transactions, (transaction: IWarehouseLoanTransaction) => transaction.uuid),
                },
            };
        }

        case WarehouseLoanTransactionAbasActionsEnum.UnallocatedTransactionsSet: {
            const typedAction: IUnallocatedTransactionsSetAction = action as IUnallocatedTransactionsSetAction;

            return {
                ...state,
                unallocatedTransactionUuids: {
                    ...state.unallocatedTransactionUuids,
                    [typedAction.abaType]: _.map(typedAction.transactions, (transaction: IWarehouseLoanTransaction) => transaction.uuid),
                },
            };
        }

        default: {
            return state;
        }
    }
}
